import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { BookMarkStore, GoodsPhoto, ComboBox, Alert, GoodsHeart, BannerAd } from '../../../js/ComponentManager'
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, Zoom } from 'swiper';

import "swiper/css";
import 'swiper/css/thumbs';
import before from '../../../img/before.svg';
import clodicon from '../../../img/clodicon.svg';
import search from '../../../img/search.svg';
import cart from '../../../img/cart.svg';
/* 개발담당:양유빈
 * 화면기능:상품검색 상세화면
 * 세부설명:
*/

export class GoodsDtl extends Component {
    static displayName = GoodsDtl.name;

    constructor(props) {
        super(props);
        this.state = {
            Content: "",
            HideName: "First2",           
            Bookmark_Store_Yn: "N",
            BasketCount:0,
            isOk: false,
            BasketDataList: [],
            GoodsCrdCombo: [],
            GoodsSizeCombo: [],
            HowProduct: [],
            OtherProduct: [],
            RetailBuyProduct: [],
            thumbsSwiper: null,
            SimilarPopShow: true
        };
        this.CsName = Big3Common.ContentState;
        //콤보 선택 후 다시 초기화
        this.refGoodsDtl = React.createRef();
        this.refCrd = React.createRef();
        this.refSize = React.createRef();

        this.Uid = "";
        this.Goods_No = "";
        
        this.RoutePosition = Big3Common.RoutePotion.Link; //메인에서는 Layer
        this.watingClick = null;    //사진 Zoom시 사용되는 변수
        this.lastClick = 0;         //사진 Zoom시 사용되는 변수
        this.InitDataInit_Yn = "Y";    //모바일 Backbutton 클릭시 초기화 문제가 있어 아래 플래그를 이용해 초기화
        
        if (this.props.ContentState !== undefined) {
            this.Uid = this.props.ContentState[this.CsName.Uid] !== undefined ? this.props.ContentState[this.CsName.Uid] : "";
            this.Goods_No = this.props.ContentState.Goods_No !== undefined ? this.props.ContentState.Goods_No : "";
        }
        
        this.handle_onScroll = this.handle_onScroll.bind(this);
        this.handleCombo_Change = this.handleCombo_Change.bind(this);
        this.handleQuan_Change = this.handleQuan_Change.bind(this);
        this.handelDelete_Click = this.handelDelete_Click.bind(this);
        this.handleCheck_Click = this.handleCheck_Click.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);
        
        this.handleStock_Click = this.handleStock_Click.bind(this);
        this.handleGoodsLink_Click = this.handleGoodsLink_Click.bind(this);
        this.handleStoreLink_Click = this.handleStoreLink_Click.bind(this);        
        this.handleZoom_Click = this.handleZoom_Click.bind(this);
        this.refCloseDataInit = this.refCloseDataInit.bind(this);
        this.Similarity_Click = this.Similarity_Click.bind(this);
    }
 
    //초기화
    async componentDidMount() {
        
        //Authentication 설정하지 않거나, 처리하지 않는다고 명시 할때만
        if (this.RoutePosition === Big3Common.RoutePotion.Link) {
            //await Big3Common.Authentication(this);
        }
        window.addEventListener('scroll', this.handle_onScroll);
        await this.CallGoodsData();
    }
    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.handle_onScroll);
    }
    //스크롤에 따라서 헤더컬러 변경
    handle_onScroll(event) {
        if (event.srcElement.scrollingElement.scrollTop >= 480 && this.state.HideName === "First2") {
            this.setState({ HideName: "First1" });
        }
        else if (event.srcElement.scrollingElement.scrollTop < 480 && this.state.HideName === "First1") {
            this.setState({ HideName: "First2" });
        }
    }
    GoodsDataSetProp = {
        CategoryModel: [],
        GoodsCrdModel: [],
        GoodsImgMgtModel: [],
        GoodsLadryModel: [],
        GoodsMatalModel: [],
        GoodsMatchaModel: [],
        GoodsMatchaBaseModel: [],
        GoodsMasterModel: [],
        GoodsSizeModel: [],
        GoodsPhotoModel: [],
        WholeInfoModel:[]
    }
   
    //조회 데이터 호출
    async CallGoodsData() {
        try {

            if (Big3Common.Util.isEmptyOrNull(this.Goods_No) || Big3Common.Util.isEmptyOrNull(this.Uid)) {
                return false;
            }
            if (this.InitDataInit_Yn === "N") {
                this.refCloseDataInit();
                console.log("refCloseDataInit");
            }
            
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post("api/Search/GoodsDtl/GetGoodsInfoAll",
                {
                    Goods_No: this.Goods_No,
                    Uid: this.Uid
                },
                true);
            
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                Object.assign(this.GoodsDataSetProp, DataList);
                let Bookmark_Store_Yn = "N";
                //장바구니 개수
                let BasketCount = this.GoodsDataSetProp.BasketCount;
                //찜여부
                if (this.GoodsDataSetProp.GoodsMasterModel.length > 0) {
                    Bookmark_Store_Yn = this.GoodsDataSetProp.GoodsMasterModel[0].bookmark_store_yn;
                }
                this.setState({
                    Bookmark_Store_Yn: Bookmark_Store_Yn,
                    BasketCount: BasketCount,
                    GoodsCrdCombo: this.GoodsDataSetProp.GoodsCrdModel,
                    GoodsSizeCombo: this.GoodsDataSetProp.GoodsSizeModel,
                    HowProduct: DataList.HowProduct,
                    OtherProduct: DataList.OtherProduct,
                    RetailBuyProduct: DataList.RetailBuyProduct
                });
                this.InitDataInit_Yn = "N";
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallGoodsData: ", e)
        }
        finally {            
            Big3Common.Util.LoadingOff();
        }
        
        return false;
    }
    //부모 페이지에서 자식페이지 호출=>새 페이지가 아닌 부모창에서 "레이어로 호출할때"
    refCallGoodsData = async (Goods_No, Uid) => {
        this.Goods_No = Goods_No;
        this.Uid = Uid;
        this.RoutePosition = Big3Common.RoutePotion.Layer;
        await this.CallGoodsData();
        
    };
    //창을 그데로 하이드 시키기 때문에 초기화 필요
    refCloseDataInit = () => {
        this.setState({
            Content: "",
            HideName: "First2",
            Bookmark_Store_Yn: "N",
            BasketCount: 0,
            isOk: false,
            BasketDataList: [],
            GoodsCrdCombo: [],
            GoodsSizeCombo: [],
            HowProduct: [],
            OtherProduct: [],
            RetailBuyProduct: [],
            thumbsSwiper: null,
            SimilarPopShow: true
        });
        //레이어 환경에서 다른 상품을 클릭할때 상품 리스트를 초기화 해야 첫번째 사진이 선택됨
        for (const prop in this.GoodsDataSetProp) {
            if (this.GoodsDataSetProp.hasOwnProperty(prop)) {
                this.GoodsDataSetProp[prop] = [];
            }
        }
        
        Big3Common.WebConfig.SimilarUseYn = "N";
        Big3Common.WebConfig.Similarity_ClickYn = "N";
        this.InitDataInit_Yn = "Y";
    }
    BasketDataModel = {
        Seq: "",
        Selected: true,
        Uid: "",
        Goods_No:"",
        Crd_Cd: "",
        Crd_Cd_Nm: "",
        SizGrp_Cd: "",
        Siz_Cd: "",
        Siz_Cd_Nm: "",
        Quan: 1,
        Goods_Price: 0,
        TotalPrice: 0
    }
    BasketDataModelInit() {
        //색상, 컬러 초기화
        this.BasketDataModel.Siz_Cd = "";
        this.BasketDataModel.Siz_Cd_Nm = "";
        this.BasketDataModel.Crd_Cd = "";
        this.BasketDataModel.Crd_Cd_Nm = "";
    }
    //사이즈, 색상선택
    handleQuan_Change(event, list, plus) {

        let Type = event.target.type;
        let Value = 0;
        let Quan = list.Quan;

        if (Quan === 1 && plus < 0) {
            
            this.setState({ Content: "구매수량은 1보다 작을수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Quan > 999) {
            this.setState({ Content: "구매수량은 1000보다 클수 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        if (Type === "text") {

            Value = event.target.value;
            if (Big3Common.Util.isNumber(Value) === false) {
                return false;
            }
            Quan = Value === "" ? "" : parseInt(Value);

        }
        else {
            Quan = Quan + (plus);
        }

        let BasketData = this.state.BasketDataList.filter(Data => Data.Seq === list.Seq);
        if (BasketData.length > 0) {
            BasketData[0].Quan = Quan;
            BasketData[0].TotalPrice = (Quan === "" ? 0 : BasketData[0].Quan * BasketData[0].Goods_Price);
            this.setState({ isOk: true });
        }
        event.preventDefault();
    }
    //상품유형 선택
    handleCombo_Change(event) {
        
        let target = event.target;
        let tagId = target.id;
        let value = target.value.trim();
        let text = target.options[target.selectedIndex].text;
        if (tagId === "cbSize") {
            this.BasketDataModel.Siz_Cd = value;
            this.BasketDataModel.Siz_Cd_Nm = text;
        }
        if (tagId === "cbColor") {
            this.BasketDataModel.Crd_Cd = value;
            this.BasketDataModel.Crd_Cd_Nm = text;
        }
         
        if (this.BasketDataModel.Siz_Cd !== "" && this.BasketDataModel.Crd_Cd !== "") {
            let Exists = this.state.BasketDataList.filter(list => list.Siz_Cd === this.BasketDataModel.Siz_Cd && list.Crd_Cd === this.BasketDataModel.Crd_Cd);
            if (Exists.length > 0) {
                
                this.setState({ Content: `${this.BasketDataModel.Siz_Cd_Nm}/${this.BasketDataModel.Crd_Cd_Nm} 항목은 이미 선택 되었습니다.` });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                this.BasketDataModelInit();
                return false;
            }
            //장바구니 담기 모델
            let basketdatamodel = Big3Common.Util.Cloen(this.BasketDataModel);
            
            let BasketDataList = Big3Common.Util.Cloen(this.state.BasketDataList);
            //****************모장바구니 모델에 기타 속성값 할당
            basketdatamodel.Seq = Big3Common.getGuid();
            basketdatamodel.Uid = this.Uid;
            basketdatamodel.Goods_No = this.Goods_No;
            basketdatamodel.TotalPrice = (this.BasketDataModel.Quan * this.BasketDataModel.Goods_Price);
            BasketDataList.push(basketdatamodel);

            this.setState({ BasketDataList: BasketDataList });
            this.BasketDataModelInit();

            this.refCrd.current.ComboInitSet();
            this.refSize.current.ComboInitSet();
        }
        event.preventDefault();
    }

    //장바구니 항목 삭제
    handelDelete_Click(event, Seq) {
        Big3Common.Util.RemoveModelListRow(this.state.BasketDataList, "Seq", Seq);
        this.setState({ isOk: true });
        event.preventDefault();
    }
    //구매항목 체크
    handleCheck_Click(event, list) {
        let BasketData = this.state.BasketDataList.filter(Data => Data.Seq === list.Seq);
        if (BasketData.length > 0) {
            BasketData[0].Selected = event.target.checked;
            this.setState({ isOk: true });
        }
        return false;
    }
    //구매하기 버튼 클릭
    async handleSave_Click(event) {
        let PostModel = this.state.BasketDataList.filter(Data => Data.Selected === true);
        if (PostModel.length === 0) {
            this.setState({ Content: "구매항목을 체크하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        try {
            
            let Data = await Big3Common.Post('api/Search/GoodsDtl/RegisterBasketMgt', { GoodsList: PostModel },true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.ModalClose(bootstrap, 'BuyModal');
                Big3Common.ModalAlert(bootstrap, 'Confirmodal');
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
            //로그기록
            Big3Common.RegisterTrackingLog({
                [Big3Common.ContentState.Page_cd]: "DP",
                [Big3Common.ContentState.Mgr_No]: null,
                [Big3Common.ContentState.Uid]: this.Uid,
                [Big3Common.ContentState.Goods_No]: this.Goods_No,
                [Big3Common.ContentState.Basket_Yn]: "Y"
            });
        }
        catch (e) {
            console.log("handleSave_Click", e);
        }
     
        event.preventDefault();
    }
     
    //재고 문의하기
    async handleStock_Click(event) {
        
        try {
            let Model = this.state.BasketDataList.filter(list => list.Selected === true);;
            if (Model.length === 0) {
                this.setState({ Content: "문의할 상품을 선택하여 주세요." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
            else {
                let DataGroup = Big3Common.Util.groupBy(Model, list => list.Uid);
                let Mstlist = [];
                let DtlList = [];
                for (const item of DataGroup.entries()) {
                    //QA: 재고문의
                    Mstlist.push({ "uid": item[0], "QST_STATUS": "QA" });
                    let itemList = item[1];
                    itemList.forEach(element => DtlList.push(element));
                }
                let Data = await Big3Common.Post('api/Chat/Answer/RegisterStockQustion', { Mstlist: Mstlist, DtlList: DtlList }, true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    this.setState({ Content: Data.message });
                    Big3Common.ModalClose(bootstrap, 'BuyModal');
                    Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                    //장바구니 리스트 초기화
                    this.setState({ BasketDataList: [] });
                }
                else {
                    this.setState({ Content: Data.message });
                    Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                }
            }
        }
        catch (e) {
            console.log("handleStock_Click", e);
        }
        event.preventDefault();
    }
    //하위 상품리스트들 클릭 할때
    async handleGoodsLink_Click(event, list) {
        this.Uid = list.uid;
        this.Goods_No = list.goods_no;
        await this.CallGoodsData();
        window.scrollTo(0, 0);
        event.preventDefault();
    }
    //상세 페이지 에서 검색을 이용할때 상세보기
    refGoodsLink_Click(event, list) {
        this.handleGoodsLink_Click(event, list);
        this.RoutePosition = Big3Common.RoutePotion.Layer;
    }
    Item_Hide = () => {
        //다른 화면으로 이동할때 레이어 지우기
        document.getElementById("child_goods_dtl").className = "item_hide";
    }
    //도매매장 방문하기
    handleStoreLink_Click = (event) => {
        this.props.RenderComponent("StoreDtl", {
            [this.CsName.Uid]: this.Uid,
            [this.CsName.Goods_No]: this.Goods_No,
            [this.CsName.BackUrl]: "GoodsDtl"
        });
        event.preventDefault();
    }
    //상품확대
    handleZoom_Click = (event) => {

        const GoodsPhotoModel = this.GoodsDataSetProp.GoodsPhotoModel;
        if (event.detail === 2) {
           
            //pc버전
            this.props.RenderComponent("GoodsZoom", {
                [this.CsName.Uid]: this.Uid,
                [this.CsName.Goods_No]: this.Goods_No,
                "GoodsPhotoModel": GoodsPhotoModel
            });
        }
        else {
           
            //모바일버전
            if (this.lastClick && event.timeStamp - this.lastClick < 250 && this.watingClick)
            {
                this.lastClick = 0;
                clearTimeout(this.watingClick);
                this.watingClick = null;
                this.props.RenderComponent("GoodsZoom", {
                    [this.CsName.Uid]: this.Uid,
                    [this.CsName.Goods_No]: this.Goods_No,
                    "GoodsPhotoModel": GoodsPhotoModel
                });
            } else {
                this.lastClick = event.timeStamp;
                this.watingClick = setTimeout(() => {
                    this.watingClick = null;
                    console.log("single click");
                }, 251);
            }
        }
        event.preventDefault();
    }
    //즐겨찾기 추가 시 항목 증가 처리
    HeartCountIncrease = (HeartYn) => {
        const Increase = HeartYn === "Y" ? 1 : -1;
        const Bookmark_Goods_Count = document.getElementById("Bookmark_Goods_Count").innerText;
        document.getElementById("Bookmark_Goods_Count").innerText = parseInt(Bookmark_Goods_Count) + (Increase);
        return false;
    }
    //유사도 검색 클릭 버튼
    Similarity_Click = (e) => {

        Big3Common.WebConfig.Similarity_ClickYn = "Y";
        this.setState({ SimilarPopShow: false });

        const TagID = `${this.Uid}_${this.Goods_No}`;
        var hiddenInput = document.getElementById('Similarity_Uid');
        hiddenInput.value = TagID;
        var event = new Event('click');
        hiddenInput.dispatchEvent(event);
        e.preventDefault();
    }
    //이전페이지 이동 ( > )
    HistoryBack() {
       
        if (this.RoutePosition === Big3Common.RoutePotion.Link) {
            return (
                <img src={before} alt="이전화면" onClick={() => { Big3Common.Util.HistoryBack(this);  }} />
            )
        }
        else {
            if (Big3Common.WebConfig.SimilarUseYn === "Y" && this.state.SimilarPopShow === true) {
                //유사도 검색을 이용했을 경우
                return (
                    <img src={before} alt="이전화면" onClick={() => { Big3Common.GoodsDtl_ShowHide(false, false); this.refCloseDataInit(); Big3Common.ModalAlert(bootstrap, "SimilarSearch") }} />
                )
            }
            else {
                return (
                    <img src={before} alt="이전화면" onClick={() => { Big3Common.GoodsDtl_ShowHide(false, false); this.refCloseDataInit(); }} />
                )
            }
            
        }
    }
    //검색 아이콘, 카트 아이콘
    HeaderLinkrender(Type, cssName) {
        const pathname = window.location.pathname;
        if (Type === "Home") {
            if (pathname === "/") {
                return (
                    <img src={clodicon} alt="홈화면" onClick={() => { Big3Common.GoodsDtl_ShowHide(false, false); this.refCloseDataInit(); }} />
                )
            }
            else {
                return (
                    <Link to="/">
                        <img src={clodicon} alt="홈화면"  />
                    </Link>
                )
            }
        }
        else if (Type === "Search") {
            if (pathname === "/Search/Goods/Index") {
                return (
                    <img src={search} alt="검색아이콘" className={cssName} onClick={() => { this.Item_Hide(); this.props.RenderComponent("SearchHome") }} />
                )
            }
            else {
                return (
                    <Link to={"/Search/Goods/Index"} className={cssName}>
                        <img src={search} alt="검색아이콘" onClick={() => { this.Item_Hide(); }} />
                    </Link>
                )
            }
        }
        else {
            return (
                <Link to="/MyPage/Basket/Index">
                    <img src={cart} alt="카트아이콘" className={cssName} onClick={() => { this.Item_Hide(); }} />
                    <span><b>{this.state.BasketCount}</b></span>
                </Link>
            )
        }
    }
    //헤더 그리기(이전, 검색, 카트 포함)
    Headerrender() {
        const HistoryBack = this.HistoryBack();
        
        return (
            <header style={this.state.HideName === "First2" ? { backgroundColor: "transparent" } : { backgroundColor: "#ffff" }}>
                <div className={this.state.HideName === "First1" ? "item_hide" : "nav nav_2"}>
                    <div className="before">
                        {HistoryBack}
                    </div>
                    <div className="header_icon_box2">
                        <div className="main_alarm">
                            {this.HeaderLinkrender('Home','') }
                        </div>
                        <div className="main_alarm">
                            {this.HeaderLinkrender('Search','white')}
                        </div>
                        <div className="main_alarm">
                            {this.HeaderLinkrender('Cart', 'white')}
                        </div>
                    </div>
                </div>
                <div className={this.state.HideName === "First2" ? "item_hide" : "nav"} >
                    <div className="before">
                        {HistoryBack}
                    </div>
                    <div className="header_icon_box2">
                        <div className="main_alarm">
                            {this.HeaderLinkrender('Home')}
                        </div>
                        <div className="main_alarm">
                            {this.HeaderLinkrender('Search','')}
                        </div>
                        <div className="main_alarm">
                            {this.HeaderLinkrender('Cart', '')}
                        </div>
                    </div>
                </div>
            </header>
            ) 
    }
    //큰 사진 그리기
    Photorender() {
        
        let GoodsPhotoList = this.GoodsDataSetProp.GoodsPhotoModel;
        if (GoodsPhotoList.length > 0) {
            let VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
            let TotalCount = GoodsPhotoList.length;
            let LayoutWidth = Big3Common.Util.offsetWidth();
            let slidersCount = 13;
            slidersCount = Math.ceil(LayoutWidth / 100) - 1;
            if (slidersCount >= 13) {
                slidersCount = 13;
            }
            else if (slidersCount <= 5) {
                slidersCount = 5;
            }
           /* const img_seach_btn_css = window.location.pathname.toLowerCase() === "/search/similar/similargoods" ? "item_hide" : "img_seach_btn";*/
            return (
                <>
                    <Swiper
                        spaceBetween={10}
                        navigation={false}
                        className="mySwiper2"
                        zoom={true}
                        modules={[Zoom, Thumbs]}
                        thumbs={{ swiper: this.state.thumbsSwiper }}
                        initialSlide="0"
                    >
                        <>
                            {
                                GoodsPhotoList.map((list, idx) =>
                                    <SwiperSlide key={list.rownum}
                                    >
                                        <div>
                                            <div className="img_box swiper-zoom-container">
                                                <img src={VirtualRoot + list.img_1000} alt="상품사진" />
                                            </div>
                                            <div className="photo_number">{idx + 1}/{TotalCount}</div>
                                            {/*<div className={img_seach_btn_css} onClick={(e) => { this.Similarity_Click(e) }}>*/}
                                            {/*    <span></span>유사상품검색*/}
                                            {/*</div>*/}
                                        </div>
                                    </SwiperSlide>
                             )}
                        </>
                    </Swiper>
                    <Swiper watchSlidesProgress={true}
                        slidesPerView={slidersCount}
                        className="mySwiper img_list_box"
                        modules={[Thumbs]}
                        onSwiper={(swiper) => this.setState({ thumbsSwiper: swiper })}
                        initialSlide="0"
                    >
                        <div>
                            {
                                GoodsPhotoList.map(list =>
                                    <SwiperSlide key={list.rownum} className="img_list"
                                        style={{ backgroundImage: `url(${VirtualRoot}${list.img_100})`, "width": "65px", height: "65px" }}
                                    >
                                    </SwiperSlide>
                                )}
                            <SwiperSlide style={{ width: "65px", height: "65px" }}>
                                {/* 공백*/}
                            </SwiperSlide>
                        </div>
                    </Swiper>
                    
                </>
            )
        }
        else {
            return("")
        }
        
    }
    //상품설명(색상,사이즈 등)
    Productrender1() {
         
        let GoodsCrdlist = this.GoodsDataSetProp.GoodsCrdModel;
        if (GoodsCrdlist.length === 0) {
            return ("");
        }
        let ColorName = GoodsCrdlist.map(list => { return list.crd_nm }).toString().replaceAll(",", ", ");
        let GoodsSizelist = this.GoodsDataSetProp.GoodsSizeModel;
        let SizeName = GoodsSizelist.map(list => { return list.siz_nm }).toString().replaceAll(",", ", ");
        let GoodsMatallist = this.GoodsDataSetProp.GoodsMatalModel;
        let MatalName = GoodsMatallist.map(list => { return `${list.matal_nm} ${list.ratio}% ` }).toString().replaceAll(",", ", ");
        let Made_Nm = "";
        let Sinsale_Nm = "";
        if (this.GoodsDataSetProp.GoodsMasterModel.length > 0) {
            Made_Nm = this.GoodsDataSetProp.GoodsMasterModel[0].made_by_nm;
            Sinsale_Nm = this.GoodsDataSetProp.GoodsMasterModel[0].sinsale_yn_nm;
        }
        let Ladry_CdNm = this.GoodsDataSetProp.GoodsLadryModel.map(list => { return list.ladry_cd_nm }).toString().replaceAll(",", ", ");

        //***************장바구니 사이즈 구룹 등록
        if (GoodsSizelist.length > 0) {
            this.BasketDataModel.SizGrp_Cd = GoodsSizelist[0].sizgrp_cd;
        }
        return (
            <div className="protuct_intro">
                <div className="title">상품설명</div>
                <div className="product_info_line first_line">
                    <div className="product_info_title">색상</div>
                    <div className="product_info_cont">{ColorName }</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">사이즈</div>
                    <div className="product_info_cont">{SizeName}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">혼용률</div>
                    <div className="product_info_cont">{MatalName}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">제조국</div>
                    <div className="product_info_cont">{Made_Nm}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">낱장여부</div>
                    <div className="product_info_cont">{Sinsale_Nm}</div>
                </div>
                <div className="product_info_line">
                    <div className="product_info_title">세탁법</div>
                    <div className="product_info_cont">{Ladry_CdNm}</div>
                </div>
            </div>

            )
    }
    //상품소재 특성
    Productrender2() {
         
        //소재정보 기준정보 값
        let GoodsMatchaBaseModel = Big3Common.Util.groupBy(this.GoodsDataSetProp.GoodsMatchaBaseModel, list => list.matgrp_nm);
        let GoodsMatchaModel = this.GoodsDataSetProp.GoodsMatchaModel;
        //render에 바인됭 리스트
        let MatchaGrp = [];
        //소재정보 셋팅
        for (const item of GoodsMatchaBaseModel.entries()) {
            //소재정보 리스트 세부 항목           
            let itemList = item[1];
            //클릭한 소재정보
            let SelectState = [];
            //소재정보에서 선택된 값이 있으면 설정
            itemList.forEach(function (items) {
                let EqualList = GoodsMatchaModel.filter(list => list.matcha_grp === items.matcha_grp && list.matcha_cd === items.matcha_cd);
                if (EqualList.length > 0) {
                    SelectState = EqualList;
                }
            });
            if (SelectState.length > 0) {
                MatchaGrp.push({ "matgrp_nm": item[0], "Childlist": item[1], "SelectState": SelectState[0] });
            }
            
        }
        
        return (
            <div className="protuct_intro">
                <div className="title">소재정보</div>
                {
                    MatchaGrp.map((list, idx) =>
                        <div className={idx === 0 ? "product_info_line first_line" : "product_info_line"} key={list.matgrp_nm}>
                            <div className="product_info_title">{list.matgrp_nm}</div>
                            {
                                list.Childlist.map(childs =>
                                    <div className="form-check product_info_check" key={childs.matcha_grp + '_' + childs.matcha_cd}>
                                        <input className="form-check-input"
                                            type="checkbox"
                                            disabled
                                            defaultChecked={childs.matcha_grp === list.SelectState.matcha_grp && childs.matcha_cd === list.SelectState.matcha_cd ? true : false}
                                            name={'matcha_' + childs.matcha_grp}
                                            style={{ opacity: "inherit" }}
                                        />
                                        <label className="form-check-label" style={{ opacity: "inherit" }}>{childs.matcha_nm}</label>
                                    </div>
                                )}
                        </div>
                    )}
               
            </div>
        )
    }
    //제품정보 상단
    ProductInforender() {
       
        let Categorys = this.GoodsDataSetProp.CategoryModel;
        let GoodsMasterModel = this.GoodsDataSetProp.GoodsMasterModel;
        if (GoodsMasterModel.length===0 || Categorys.length === 0) {
            return ("");
        }
        let Goods_Nm = GoodsMasterModel[0].goods_nm;
        let Goods_Price = GoodsMasterModel[0].goods_price;
        let Dtl_Content = GoodsMasterModel[0].dtl_content;
        let Reg_Dt = GoodsMasterModel[0].reg_dt;
        let Strqst_Yn = GoodsMasterModel[0].strqst_yn;

        //***************장바구니 모델에 가격 할당
        this.BasketDataModel.Goods_Price = Goods_Price;
        return (
            <>
                <div className="pre_Category">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">{Categorys[0].man_nm }</li>
                        <li className="breadcrumb-item">{Categorys[0].mid_nm}</li>
                        <li className="breadcrumb-item">{Categorys[0].sub_nm}</li>
                    </ol>
                </div>
                <div className="update">최신등록일자 : {Reg_Dt }</div>
                <div className="pre_title">{Goods_Nm}</div>
                <div className="pre_price">{Strqst_Yn === "Y" ? `${Big3Common.Util.Money(Goods_Price)}원 (매장문의)` : `${Big3Common.Util.Money(Goods_Price)}원` }</div>
                <div className="protuct_intro">
                    <div className="title">제품설명</div>
                    <div className="product_txt" style={{ whiteSpace: 'pre-line' }}>{Dtl_Content }
                    </div>
                </div>
            </>
            )
    }
    //장바구니 등록 리스트(개수변경,주문서 모달에 포함)
    BuyGoodsBoxrender() {
        let BasketDataList = this.state.BasketDataList;
        if (BasketDataList.length === 0) {
            return ("");
        }
        return (
            <div className="modal_selected_box">
                {BasketDataList.map((list) =>
                    <div className="selected_box" key={list.Seq}>
                        <div className="title_box">
                            <div className="form-check">
                                <input className="form-check-input"
                                    type="checkbox"
                                    onChange={(e) => { this.handleCheck_Click(e, list) }}
                                    checked={list.Selected}
                                />
                                <div className="form-check-label">{list.Siz_Cd_Nm} / {list.Crd_Cd_Nm}</div>
                                <div className="product_delete" onClick={(e) => this.handelDelete_Click(e, list.Seq) }></div>
                            </div>
                        </div>
                        <div className="product_order_data">
                            <div className="number_check">
                                <button type="button" onClick={(e) => { this.handleQuan_Change(e, list, -1) }}
                                >-</button>
                                <input type="text" className="form-control" value={list.Quan}
                                    maxLength="3"
                                    onChange={(e) => { this.handleQuan_Change(e, list, 0) }}
                                />
                                <button type="button" className="btn_2"
                                    onClick={(e) => { this.handleQuan_Change(e, list, 1) }}
                                >+</button>
                            </div>
                            <div className="product_price">{Big3Common.Util.Money(list.TotalPrice)}원</div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
    //주문서 모달
    Buyrender() {
         
        let BuyGoodsBoxrender = this.BuyGoodsBoxrender();
        
        let SumPrice = 0;
        let ProductCount = this.state.BasketDataList.length;
        if (ProductCount > 0) {
            //Accumulator는 누산기, currentValue:현재 값
            SumPrice = this.state.BasketDataList.map(list => list.TotalPrice).reduce((Accumulator, currentValue) => Accumulator + currentValue);
        }
        return (
            <div className="modal fade show" id="BuyModal" aria-modal="true" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header modal-header_v2">
                            <h5 className="modal-title h4">옵션</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body modal-body_v2">
                            <div className="modal_select_box">
                                <div className="m_select_box">
                                    <ComboBox id="cbSize"
                                        textName="siz_nm"
                                        valueName="siz_cd"
                                        emptyText="사이즈 선택하기"
                                        optionList={this.state.GoodsSizeCombo}
                                        ComboChange={this.handleCombo_Change}
                                        ref={this.refSize}
                                    />
                                </div>
                                <div className="m_select_box">
                                    <ComboBox id="cbColor"
                                        textName="crd_nm"
                                        valueName="crd_cd"
                                        emptyText="색상 선택하기"
                                        optionList={this.state.GoodsCrdCombo}
                                        ComboChange={this.handleCombo_Change}
                                        ref={this.refCrd}
                                    />
                                </div>
                            </div>
                            {BuyGoodsBoxrender }
                            <div className="modal_order_btn_box">
                                <div className="all_price">
                                    <div className="number">총 {ProductCount}개의 상품</div>
                                    <div className="price">
                                        <span>총 금액</span>
                                        {Big3Common.Util.Money(SumPrice)}원
                                    </div>
                                </div>
                                <div className="order_btn_box">
                                    <button className="order_btn btn_v1" onClick={(e) => { this.handleStock_Click(e) }}>재고문의</button>
                                    <button className="order_btn btn_v1" onClick={this.handleSave_Click }>장바구니 담기</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )
    }
    //최종 구매 모달창
    BuyModalrender() {
        return (
            <div className="modal fade show" id="Confirmodal" aria-modal="true" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header modal-header_v2">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body modal-body_v2">
                            <div className="modal_order_btn_box modal_order_btn_box_v2">
                                <div className="all_price">
                                    선택한 상품이 장바구니로 이동하였습니다.
                                </div>
                                <div className="order_btn_box">
                                    <button className="order_btn btn_v1" onClick={() => { this.Item_Hide(); window.location.href = '/MyPage/Basket/Index'; }}>장바구니 이동</button>
                                    <button className="order_btn btn_v1" onClick={() => {
                                        Big3Common.ModalClose(bootstrap, 'Confirmodal');
                                        if (this.RoutePotion === Big3Common.RoutePotion.Link) {
                                            this.Item_Hide();
                                            Big3Common.Util.HistoryBack(this);
                                        }
                                        else {
                                            Big3Common.GoodsDtl_ShowHide(false, false);
                                            this.refCloseDataInit();
                                        }
                                        
                                    }}>쇼핑 계속하기</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       )
    }
   
    //이상품 어때요, 같은매장 다른상품, 다른 소매 고객들이 함께 선택한 상품
    etcProductrender(DataList, flag) {

        if (DataList.length === 0) {
            return ("");
        }

        let HowCount = this.state.HowProduct.length;
        let OtherCount = this.state.OtherProduct.length;
        let RetailBuyCount = this.state.RetailBuyProduct.length;
        let Title = "";
        let Style = "recent_product u_padding";
        //f_margin 값은 항상 마지막 일때 붙음
        if (flag === "A") {
            Title = "이상품 어때요";
            if ((OtherCount === 0 && RetailBuyCount === 0) ) {
                Style = "recent_product u_padding f_margin";
            }
        }
        else if (flag === "B") {
            Title = "같은매장 다른상품";
            if ((HowCount === 0 && RetailBuyCount === 0) || (HowCount > 0 && RetailBuyCount === 0) ) {
                Style = "recent_product u_padding f_margin";
            }
        }
        else if (flag === "C") {
            Title = "다른 소매 고객들이 함께 선택한 상품";
            if ((HowCount === 0 && OtherCount === 0) || (HowCount > 0 || OtherCount > 0)) {
                Style = "recent_product u_padding f_margin";
            }
        }
        const slidersCount = 3;
        return (
            <>
                <div className="line_v2"></div>
                <div className={Style} >
                    <div className="title_box">
                        <div className="title">{Title}</div>
                    </div>
                    <div className="recent_poroducts row row-cols-3 no_line">
                        <Swiper watchSlidesProgress={true} slidesPerView={slidersCount} className="recent_poroducts row row-cols-3 no_line">
                            <div>
                                {
                                    DataList.map((list, idx) =>
                                        <SwiperSlide className="product" key={idx} onClick={(e) => { this.handleGoodsLink_Click(e, list) }}>
                                            <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                                Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                                                CallBack={this.CallBoorkMarkGoodsData}
                                                SoldoutYn={list.soldout_yn}
                                            />
                                            <div className="shop_name">{list.org_nm}</div>
                                            <div className="product_name">{list.goods_nm}</div>
                                            <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원` }</div>
                                            {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                                        </SwiperSlide>

                                    )}
                            </div>
                            <SwiperSlide className="word_box3">
                                {/* 공백*/}
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </>
       )
    }
    //도매홈페이지 링크
    BuyerLinkrender(Whole_Name) {

        const pathName = window.location.pathname.toLowerCase();
        const urlLink = `/Search/Goods/Index?Uid=${this.Uid}`;
        if (this.RoutePosition === Big3Common.RoutePotion.Link) {
            return (
                <div className="name" onClick={(e) => { this.Item_Hide(); this.handleStoreLink_Click(e); }}>{Whole_Name}<span className="go_s"></span></div>
            )
        }
        else if (pathName === "/search/goods/index") {
            return (
                <div className="name" onClick={() => { this.Item_Hide() }}>{Whole_Name} <a href={urlLink}><span className="go_s"></span></a></div>
            )
        }
        else {
            const urlLink = `/Search/Goods/Index?Uid=${this.Uid}`;
            return (
                <div className="name" onClick={() => { this.Item_Hide() }}><Link to={urlLink}>{Whole_Name}<span className="go_s"></span></Link></div>
            )
        }
    }
    render() {
        
        const Headerrender = this.Headerrender();
        const Photorender = this.Photorender();
        const Productrender1 = this.Productrender1();
        const Productrender2 = this.Productrender2();
        const ProductInforender = this.ProductInforender();
               
        const Buyrender = this.Buyrender();
        const BuyModalrender = this.BuyModalrender();

        const GoodsMasterModel = this.GoodsDataSetProp.GoodsMasterModel;
        const WholeInfoModel = this.GoodsDataSetProp.WholeInfoModel;
        if (GoodsMasterModel.length === 0) {
            return false;
        }
        
        let Bld_Name, Flr_Name, Whole_No_Name, Whole_Name, User_Phone, Whole_Code = "";
        if (WholeInfoModel.length > 0) {
            Bld_Name = WholeInfoModel[0].bld_name;
            Flr_Name = WholeInfoModel[0].flr_name;
            Whole_No_Name = WholeInfoModel[0].whole_no_name;
            Whole_Name = WholeInfoModel[0].whole_name;
            User_Phone = WholeInfoModel[0].user_phone;
            Whole_Code = WholeInfoModel[0].whole_code;
        }
        let Bookmark_Goods_Count = GoodsMasterModel.length === 0 ? 0 : GoodsMasterModel[0].bookmark_goods_count;
        let Bookmark_Goods_Yn = GoodsMasterModel.length === 0 ? "N" : GoodsMasterModel[0].bookmark_goods_yn;
        return (
            <div ref={this.refGoodsDtl }>
                {Headerrender }
                <div className="pre_wrap">
                    {Photorender }
                    <div className="gdl_shop_info_box">
                        <div className="shop_info shop_info2">
                            <div className="shop_name">
                                {this.BuyerLinkrender(Whole_Name) }
                                <div className="shop_icon_box">
                                    <div className="call" onClick={() => { window.location.href=`tel:${User_Phone}` } } ></div>
                                    <BookMarkStore
                                        Whole_Code={Whole_Code}
                                        HeartOn={this.state.Bookmark_Store_Yn === "Y" ? true : false}
                                    />
                                </div>
                            </div>
                            <div className="shop_name">
                                <div className="add">{`${Bld_Name} ${Flr_Name}층 ${Whole_No_Name}호`}</div>
                                <div className="shop_icon_box">
                                    <Link to={`/Chat/LiveChat/Index?uid=${this.Uid}`} onClick={() => { this.Item_Hide() } }>
                                        <button>채팅하기</button>
                                    </Link>
                                </div>
                            </div>      
                        </div>
                    </div>
                    <div className="line_v2"></div>
                    <div className="pre_content_wrap">
                        {ProductInforender}
                        {Productrender1 }
                        {Productrender2 }
                    </div>
                </div>
                {this.etcProductrender(this.state.HowProduct, 'A')}
                <BannerAd id="GoodsDtlBanner" ads_loc_cd="GD" ads_type_detail_cd="SB" />
                {this.etcProductrender(this.state.OtherProduct, 'B')}
                {this.etcProductrender(this.state.RetailBuyProduct, 'C')}
                <div className="order_box_v2">
                    <div className="zzim_box">
                        <GoodsHeart
                            Bookmark={{ Goods_No: this.Goods_No, Uid: this.Uid, Bookmark_Yn: Bookmark_Goods_Yn }}
                            CallBack={this.HeartCountIncrease }
                        />
                        <div className="view" id="Bookmark_Goods_Count">{Big3Common.Util.Money(Bookmark_Goods_Count)}</div>
                    </div>
                    <div className="orderbtn_box">
                        <button onClick={(e) => { Big3Common.ModalAlert(bootstrap,'BuyModal') }}>구매하기</button>
                    </div>
                </div>          
                {Buyrender}
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="구매안내"
                />
                {BuyModalrender}
                
            </div>
        );
    }
}
